// tslint:disable

import * as classNames from "classnames";
import * as React from "react";
// import * as myClasses from "../";

import "react-google-maps";

import { HTMLDivProps } from "@blueprintjs/core";

import { Alignment, Classes, MPDButton } from "src/mpd-library";

export interface IZoomControlProps extends HTMLDivProps {
  alignment?: Alignment;
  hide?: boolean;
  zoomControlsActive?: boolean;
  onZoomChanged(event: any, type: string): void;
}

import "./styles.css";

export const ZoomControls: React.SFC<IZoomControlProps> = props => {
  const {
    alignment,
    hide,
    className,
    zoomControlsActive,
    onZoomChanged
  } = props;
  const classes = classNames(
    "geo-map-zoom-controls-container",
    Classes.alignmentClass(alignment || Alignment.RIGHT),
    zoomControlsActive && Classes.ACTIVE,
    className
  );

  if (hide) {
    return null;
  }

  return (
    <div className={classes}>
      <MPDButton
        className="zoom-in"
        name="plus"
        onClick={e => onZoomChanged(e, "zoom-in")}
      />
      <MPDButton
        className="zoom-out"
        name="minus"
        onClick={e => onZoomChanged(e, "zoom-out")}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/maps/geo-map/zoom-controls.tsx